module.exports = __webpack_public_path__ + "img/web3_3.c5a831f8.jpg";